import localStore from '@theme/local-store'
import { Component } from '@theme/component'

class Vehicle extends Component {
  constructor() {
    super()
    /** @type {(e: Event) => void} */
    this._onClick = this._onClick.bind(this)
    /** @type {(e: Event) => void} */
    this._onChange = this._onChange.bind(this)
    /** @type {(e: CustomEvent) => void} */
    this._onVehicleChanged = this._onVehicleChanged.bind(this)
    this._localStore = localStore
  }

  connectedCallback() {
    super.connectedCallback?.()
    this.addEventListener('click', this._onClick, { capture: true })
    this.addEventListener('change', this._onChange, { capture: true })
    document.addEventListener('vehicle:changed', this._onVehicleChanged)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick, { capture: true })
    this.removeEventListener('change', this._onChange, { capture: true })
    document.removeEventListener('vehicle:changed', this._onVehicleChanged)
    super.disconnectedCallback?.()
  }

  /**
   * @param {Event} e
   */
  _onClick(e) {
    const target = /** @type {Element|null} */ (
      e.composedPath?.()[0] ?? e.target
    )
    if (!(target instanceof Element)) return

    // Acepta click en cualquier elemento dentro de la tarjeta
    const el = target.closest('[data-vehicle]')
    if (!el) return

    const vehicle = el.getAttribute('data-vehicle') || ''
    if (!vehicle) return

    try {
      const payload = {
        // handle del vehículo (ej: slug)
        vehicle: el.getAttribute('data-vehicle') || '',
        // nombre legible; mantenemos 'label' por compatibilidad
        label: el.getAttribute('data-vehicle-name') || '',
        name: el.getAttribute('data-vehicle-name') || '',
        // id de metaobject
        id: el.getAttribute('data-vehicle-id') || '',
        // make/brand handle
        make: el.getAttribute('data-make') || '',
        // imagen (url)
        image: el.getAttribute('img') || '',
        // filtro de colección
        handle: el.getAttribute('handle') || '',
      }

      // Guardamos como objeto; localStore hace JSON.stringify internamente
      this._localStore.set('vehicle', payload)

      this._setSelectedVehicle(vehicle)
      document.dispatchEvent(
        new CustomEvent('vehicle:changed', {
          detail: { vehicle },
          bubbles: true,
        })
      )
    } catch (err) {
      console.error('VehicleMake click handler error:', err)
    }
  }

  /**
   * @param {Event} e
   */
  _onChange(e) {
    const target = /** @type {Element|null} */ (
      e.composedPath?.()[0] ?? e.target
    )
    if (!(target instanceof Element)) return

    // Alternativa: <select data-vehicle-select>
    if (target.matches('select[data-vehicle-select]')) {
      const value = /** @type {HTMLSelectElement} */ (target).value
      if (!value) return
      try {
        // En flujos de <select> solo tenemos el handle; guardamos mínimo
        this._localStore.set('vehicle', { vehicle: value })
        // UI: marcar vehículo seleccionado desde <select>
        this._setSelectedVehicle(value)
        document.dispatchEvent(
          new CustomEvent('vehicle:changed', {
            detail: { make: value },
            bubbles: true,
          })
        )
      } catch (err) {
        console.error('VehicleMake change handler error:', err)
      }
    }
  }

  /**
   * Maneja el evento global `vehicle:changed` para sincronizar la UI.
   * @param {CustomEvent} e
   */
  _onVehicleChanged(e) {
    const detail = /** @type {{ vehicle?: string }} */ (e.detail || {})
    if (detail?.vehicle) {
      this._setSelectedVehicle(detail.vehicle)
    }
  }

  /**
   * Marca el vehículo seleccionado y limpia selecciones previas.
   * @param {string} vehicle
   */
  _setSelectedVehicle(vehicle) {
    try {
      // Limpiar selección previa
      document
        .querySelectorAll('[data-vehicle].selected')
        .forEach((n) => n.classList.remove('selected'))
      // Marcar todos los nodos que representen este vehículo
      document
        .querySelectorAll(`[data-vehicle="${CSS.escape(vehicle)}"]`)
        .forEach((n) => n.classList.add('selected'))
    } catch (_) {
      // noop
    }
  }
}

if (!customElements.get('vehicle-component')) {
  customElements.define('vehicle-component', Vehicle)
}
